export type RealtimeEndpoints = {
  endpoints: { transport: 'websocket' | 'http_stream' | 'sse'; endpoint: string }[];
  emulationEndpoint: string | undefined;
};

const WEBSOCKET_SUFFIX = '/connection/websocket';

/**
 * The token endpoint returns the WebSocket URL. The server serves the HTTP fallbacks beside it
 * (`/connection/http_stream`, `/connection/sse`) plus `/emulation` for client-to-server
 * commands on those transports, so the whole fallback list derives from one URL.
 */
export function realtimeEndpoints(websocketUrl: string): RealtimeEndpoints {
  const websocket = { transport: 'websocket' as const, endpoint: websocketUrl };
  const url = URL.canParse(websocketUrl) ? new URL(websocketUrl) : null;
  if (url === null || !url.pathname.endsWith(WEBSOCKET_SUFFIX)) {
    return { endpoints: [websocket], emulationEndpoint: undefined };
  }

  const httpBase = new URL(websocketUrl);
  httpBase.protocol = url.protocol === 'wss:' ? 'https:' : 'http:';
  const prefix = url.pathname.slice(0, -WEBSOCKET_SUFFIX.length);
  const at = (path: string) => `${httpBase.origin}${prefix}${path}`;
  return {
    endpoints: [
      websocket,
      { transport: 'http_stream', endpoint: at('/connection/http_stream') },
      { transport: 'sse', endpoint: at('/connection/sse') },
    ],
    emulationEndpoint: at('/emulation'),
  };
}
